import React from 'react'
import { Box, Button, Flex, Text, useAppTheme } from '@workwhile/ui'
import { Download, Loader } from 'lucide-react'
import { ListingFunnelStep } from 'api/admin/listing/getListingFunnel'
import { useListingFunnelExport } from 'queries/listings/useListingFunnelExport'

const stepStyles = {
  border: '1px solid',
  borderColor: 'neutrals.100',
  borderRadius: 'small',
  p: 2,
} as const

type Props = {
  listingId: number
  steps: ListingFunnelStep[]
  exportTimeRange: { startDate: string; endDate: string }
}

export const ListingFunnelSteps = ({
  listingId,
  steps,
  exportTimeRange,
}: Props) => {
  const { colors } = useAppTheme()
  const { exportStep, exportingEventType, exportError } =
    useListingFunnelExport(listingId)

  return (
    <>
      {exportError ? (
        <Text fontSize={1} color={colors.errors[200]} mt={2}>
          {exportError}
        </Text>
      ) : null}
      <Flex mt={2} gap={2} width="100%">
        {steps.map((s) => {
          const isExportDisabled =
            !s.users || exportingEventType === s.eventType

          return (
            <Box
              key={s.eventType}
              flex="1 1 0"
              minWidth={0}
              {...stepStyles}
              py={1}
            >
              <Flex
                justifyContent="space-between"
                alignItems="flex-start"
                gap={1}
                mb={1}
              >
                <Text fontSize={1} color="lightText" flex={1}>
                  {s.name}
                </Text>
                <Button
                  kind="small"
                  variant="text"
                  onClick={() => exportStep(s.eventType, exportTimeRange)}
                  disabled={isExportDisabled}
                  title="Export user information"
                  aria-label={`Export user information for ${s.name}`}
                  style={{ padding: 4, opacity: isExportDisabled ? 0.4 : 1 }}
                >
                  {exportingEventType === s.eventType ? (
                    <Loader size={14} />
                  ) : (
                    <Download size={14} />
                  )}
                </Button>
              </Flex>
              <Text fontSize={2}>{s.users}</Text>
              {s.conversionFromPrev != null ? (
                <Text fontSize={1} color="lightText">
                  {(s.conversionFromPrev * 100).toFixed(1)}% of previous
                </Text>
              ) : null}
            </Box>
          )
        })}
      </Flex>
    </>
  )
}
